import React from 'react';
import { IQuestion, IQuestionAnswer } from '@/components/staffer/Grading/types';
import { renderStimuli } from '@/components/staffer/Grading/utils';
import TeacherCommentAndScore from '@/components/staffer/Grading/TeacherCommentAndScore';
import AnswerKey from '@/components/staffer/Grading/QuestionCards/AnswerKey';
import StudentAnswerInformation from '@/components/staffer/Grading/QuestionCards/StudentAnswerInformation';
import styles from '@/components/staffer/Grading/QuestionCards/questionCard.module.scss';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';

interface BaseCardProps {
  children: ReactChildren;
  question: IQuestion;
  questionAnswer?: IQuestionAnswer;
  studentAnswerHtml?: ReactChildren;
}

const BaseCard = ({ children, question, questionAnswer, studentAnswerHtml }: BaseCardProps) => {
  const { assignment, isTeacher } = useGradingStore();
  const { show_answers_to_students: showAnswersToStudents } = assignment || {};

  const renderStudentAnswer = () => (
    <>
      <StudentAnswerInformation updatedAt={questionAnswer?.answer_updated_at} />
      <div className={`${styles.studentResponse} ${questionAnswer ? styles.answered : styles.unanswered}`}>
        {studentAnswerHtml}
      </div>
    </>
  );

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        Question {question.display_position}
      </div>
      <div className={styles.bodyWrapper}>
        {renderStimuli(question)}
        {children}
        {renderStudentAnswer()}
        {(isTeacher || showAnswersToStudents) && <AnswerKey question={question} />}
        <TeacherCommentAndScore
          question={question}
          questionAnswer={questionAnswer}
        />
      </div>
    </div>
  );
};

export default BaseCard;
